<template>
  <b-modal 
    id="fare-brands-modal" 
    ref="fare-brands-modal-ref" 
    hide-footer
    header-class="fare-brands-modal-header"
    :title="title"
  >
    <h5>Additional Inclusions</h5>
    <div class="mt-5 mb-3">
      <h6 class="my-1">Your airfare includes the following fare brand attributes:</h6>
      <hr />
      <ul class="p-0">
        <li v-for="(brand, index) in brandsWithText" :key="index" class="py-3">
          <span class="d-flex">
            <i class="material-icons text-success pr-2">check_circle</i>
            {{ brand.vt_text }}
          </span>
        </li>
      </ul>
    </div>
  </b-modal>
</template>
  
<script>
export default {
  name: 'FareBrandsModal',
  props: {
    title: {
      type: String
    },
    fareBrands: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    brandsWithText() {
      return this.fareBrands.filter(b => b.vt_text);
    }
  },
  methods: {
    showModal() {
      this.$refs["fare-brands-modal-ref"].show();
    }
  },
}
</script>
  
<style lang="scss">
  .fare-brands-modal-header {
    padding: 1rem 1rem 0 1rem !important;
    border-bottom: none !important;
  }
</style>